<template>
  <div id="vue_container" class="search-page">
    <GlobalSearch />
    <Tabs class="tabs mb-2 my-md-5"/>
    <TabsContent />
    <EmptyState
      v-if="noResults"
      :state-info="I18n.t('auctions_catalogs.lack_of_auctions')"
    />
    <div v-if="!queryProvided" class="filters__no-results text-center">
      <span class="icon icon-not_searched"/>
      <p>{{ I18n.t("search_page.search.placeholder") }}</p>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import EmptyState from '@/shared/components/empty_state';
  import GlobalSearch from './search_box';
  import Tabs from './tabs';
  import TabsContent from './tabs_content';

  export default {
    name: 'SearchPage',
    components: {
      GlobalSearch,
      Tabs,
      TabsContent,
      EmptyState,
    },
    computed: {
      ...mapGetters(['totalArtworksCount', 'anyArtworksFilterActive',
        'tooManyResultsValue']),
      queryProvided() {
        const query = this.$route.query;

        return query.main_query || query.artist_id;
      },
      noResults() {
        return this.queryProvided && this.totalArtworksCount === 0;
      },
    },
    created() {
      this.getArtworksCategories();
    },
    methods: mapActions(['getArtworksCategories']),
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/search_page.vue?c796dd5c